import update from 'immutability-helper';
import {
  DIALOG_FULLSCREEN_OPEN,
  DIALOG_FULLSCREEN_CLOSE,
  INFO_CONSOLE_TOGGLE,
  MOBILE_WELCOME_ACKNOWLEDGE,
  SLIDE_ROTATION_PAUSE_TOGGLE,
} from '../actions/ActionTypes';

import getReadStatusKeyName from '../utils/getReadStatusKeyName.js';

const initialState = {
  console: {
    isOpen: false,
  },
  fullscreenPanel: {
    isOpen: false,
    props: {}
  },
  isMobileWelcomeAcknowledged: false,
  slideRotation: {
    isPaused: false
  }
};

export function ui(state = initialState, action) {
  switch (action.type) {
  case INFO_CONSOLE_TOGGLE:
    return update(state, {
      console: {
        $toggle: ['isOpen']
      }
    });
  case DIALOG_FULLSCREEN_OPEN: {
    const props = action.payload || {};
    return update(state, {
      fullscreenPanel: {
        isOpen: {
          $set: true
        },
        props: {
          $set: props
        }
      }
    });
  }
  case DIALOG_FULLSCREEN_CLOSE:
    return update(state, {
      fullscreenPanel: {
        isOpen: {
          $set: false
        }
      }
    });
  case 'INVITE_RECEIVE': {
    return update(state, {
      isMobileWelcomeAcknowledged: {
        $set: localStorage.getItem(getReadStatusKeyName(action.payload)) !== null
      }
    });
  }
  case MOBILE_WELCOME_ACKNOWLEDGE:
    return update(state, {
      isMobileWelcomeAcknowledged: {
        $set: true
      }
    });
  case SLIDE_ROTATION_PAUSE_TOGGLE: {
    return update(state, {
      slideRotation: {
        $toggle: ['isPaused']
      }
    });
  }
  default:
    return state;
  }
}
